import { IModalSplit, IOwnershipMode } from './../store/types/city';


export const PASSENGER_DISTANCE_TRAVELED_COEFFICIENTS = { // Passenger Distance Traveled
  intercept: {
    lowerBound: -1132.3,
    upperBound: 97.371,
  },
  slope: {
    lowerBound: 0.636,
    upperBound: 1.101,
  },
}

// ModalSplitGrowthRates
// BAU = Business as Usual
/* tslint:disable:object-literal-sort-keys */
export const MODAL_SPLIT_BY_TYPE_BAU_GROWTH: IModalSplit = {
  car: 0.0048,
  twoWheel: -0.0019,
  threeWheel: 0.0023,
  publicTransit: -0.0053,
}

export const MODAL_SPLIT_BY_OWNERSHIP_BAU_GROWTH: IOwnershipMode = {
  autoRickshaw: {
    commercial: 0,
  },
  car: {
    commercial: 0.0058,
    private: -0.0057,
    public: 0,
  },
  publicTransit: {
    bus: -0.01,
    metro: 0.0097,
  },
  twoWheel: {
    commercial: 0.0004,
    private: -0.0004,
  },
}



// WEBPACK FOOTER //
// ./src/data/modelConstants.ts